import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1efed22f&"
import script from "./App.vue?vue&type=script&lang=lang&"
export * from "./App.vue?vue&type=script&lang=lang&"
import style0 from "./App.vue?vue&type=style&index=0&id=1efed22f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports